import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { toast } from "../../utils/toast";

// Every higher learning institution, for linking an HLI admin to the one whose loans it manages
export const useInstitutions = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ["allHli"],
    enabled,
    staleTime: 5 * 60 * 1000,
    // The bearer token is added by the axios interceptor (src/auth/http.js)
    queryFn: async () => {
      try {
        return (await axios.get(`${process.env.REACT_APP_BASE_URL}hec/hli/getAllHli`)).data ?? [];
      } catch (error) {
        console.error("Failed to load institutions:", error);
        toast.error("Failed to load institutions", { id: "all-hli-error" });
        throw error;
      }
    },
  });
